var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chrome-dashboard',{attrs:{"enabled":_vm.fetched}},[(_vm.fetched)?_c('list-box',{class:( _obj = {}, _obj[_vm.$style.listWrapper] = true, _obj[_vm.$style.isEmpty] = _vm.list.length === 0, _obj ),attrs:{"title":"Components","enable-search":true,"is-loading":_vm.isSearchLoading,"list":_vm.list,"page-number":_vm.page.number,"page-size":_vm.page.size,"record-count":_vm.page.recordCount,"route":function (data) { return ({
      name: 'component',
      params: {
        componentId: data.id,
      },
    }); }},on:{"delete":_vm.askDelete,"page":function($event){_vm.load($event); _vm.fetchOnRouteChange = false;}},scopedSlots:_vm._u([{key:"innerHead",fn:function(){return [(_vm.list.length)?_c('router-link',{staticClass:"button-bar",attrs:{"tag":"button","title":"Add new component","to":{
          name: 'component',
          params: {
            componentId: 'create',
          },
        }}},[_vm._v(" ㊉ Add ")]):_vm._e()]},proxy:true},{key:"noData",fn:function(){return [_c('p',{class:_vm.$style.emptyRecords},[_vm._v(" Adding components to your library helps build transparency in your supply chain and increase your confidence during production, distribution and sales. ")]),_c('router-link',{staticClass:"large primary",attrs:{"tag":"button","to":{
          name: 'component',
          params: {
            componentId: 'create',
          },
        }}},[_vm._v(" Add first component ")])]},proxy:true},{key:"row",fn:function(ref){
        var row = ref.row;
return [_vm._v(" "+_vm._s(row.data.name)+" ")]}}],null,false,3799264858)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }